import { toast } from "react-toastify";
import usePaginator from "../../../../theme/Component/usePaginator";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import useModal, { MODAL_md, MODAL_SM } from "../../../../theme/Component/hooks/useModal";
import { useEffect, useState } from "react";
import { _single, _UBLDiscrepancyResponse } from "../../../../../core/services/dataBean/EntityCatalog";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { SelectUBLDocumentTypeConstants } from "./SelectUBLDocumentTypeConstants";

interface ComponentData {
    isModal?: boolean;
    _onChange?: Function;
}

export const UBLDiscrepancyResponse = ({ isModal, _onChange }: ComponentData) => {

    const { instance, bean, setBean, lista, setLista, validateForm, isMissing, isRequired, addRequiredFields } = useDataBean(_UBLDiscrepancyResponse);
    const paginator = usePaginator();

    const [regex, setRegex] = useState<string>("");
    const [type, setType] = useState<number | null>();

    const modal = useModal("", MODAL_md);
    const modalC = useModal("Eliminar Tipo de Discrepancia de Documentos", MODAL_SM);

    const hasDocumentType = (value: number | null | undefined): value is number => value !== null && value !== undefined;

    useEffect(() => {
        addRequiredFields(["Code", "Name"]);
    }, [])

    useEffect(() => {
        if (!hasDocumentType(type)) {
            toast.info("Se debe seleccionar un Tipo de Documento")
            return;
        }
        getLista();
    }, [paginator.page])

    const getLista = () => {
        if (!hasDocumentType(type)) {
            return;
        }

        instance.getUBLDiscrepancyResponseCatalog(type, regex, paginator.page, 15).then(
            (resp: any) => {
                paginator.setPages(resp.NumberOfPages);
                paginator.setRecords(resp.NumberOfPages * 15);
                setLista(resp.List);
            }
        ).catch(err => {
            toast.error("Error al cargar la lista de Tipos de Discrepancias de Documentos");
        });
    };

    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
        });
        modal.open("Crear tipo de AIU");
    }

    const deleteItem = () => {
        instance.deleteUBLDiscrepancyResponse(bean.IDUBLDiscrepancyResponse).then(
            (resp) => {
                modalC.close();
                getLista();
            }
        ).catch(err => { toast.error(err) })
    };

    const editaItem = (obj: any) => {
        if (!validateForm()) {
            toast.error("Faltan campos obligatorios por diligenciar");
            return;
        }

        instance.updateUBLDiscrepancyResponse(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDUBLDiscrepancyResponse', visible: true },
        { title: 'Codigo', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripcion', property: 'Description', visible: true },
        { title: 'Creado por', property: 'EmployeeName', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar Tipo de Discrepancia de Documento ${bean.Name}`) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const setValue = (e: any) => {
        _onChange?.(e);
        setBean(e);
    }

    const baseComponent = () => {
        return (
            <>
                <div className="row">
                    <div className="col-md-6">
                        <SelectUBLDocumentTypeConstants idSelector={type} onChange={(e) => { setType(e) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Busqueda por Texto</label>
                        <input type="text" className="form-control" value={regex} onChange={(e) => { setRegex(e.target.value) }} />
                    </div>
                    <div className="col-md-6">
                        <BasicButton icon="ri-seach-line" useMargin eventClick={() => {
                            if (!hasDocumentType(type)) {
                                toast.info("Se debe seleccionar un Tipo de Documento")
                                return;
                            }
                            getLista();
                        }}>Buscar</BasicButton>
                    </div>
                    <div className="col-md-12">
                        <BasicTable
                            body={lista}
                            head={head}
                            rowSet={setValue}
                            listButtons={listaBotones()}
                            iconButtons={iconButtonsItem}
                            records={paginator}
                        />

                        <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                            <div className="row">
                                <div className="col-md-6">
                                    <label className={`${isMissing('DocumentType') ? 'has-error' : ''}`}>Tipo Documento {isRequired('DocumentType') ? <span className="text-danger">*</span> : ''}</label>
                                    <SelectUBLDocumentTypeConstants label=" " idSelector={bean.DocumentType} onChange={(e) => { setBean({ ...bean, DocumentType: e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label className={`${isMissing('Code') ? 'has-error' : ''}`}>Codigo {isRequired('Code') ? <span className="text-danger">*</span> : ''}</label>
                                    <input className="form-control" type="text" value={bean.Code ?? ""} onChange={(e) => { setBean({ ...bean, Code: e.target.value }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label className={`${isMissing('Name') ? 'has-error' : ''}`}>Nombre {isRequired('Name') ? <span className="text-danger">*</span> : ''}</label>
                                    <input className="form-control" type="text" value={bean.Name ?? ""} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                                </div>
                                <div className="col-md-12">
                                    <label>Descripcion</label>
                                    <textarea className="form-control" value={bean.Description ?? ""} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                                </div>
                            </div>
                        </Modal>

                        <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                            <strong>Eliminar item {bean.Name}</strong>
                        </ModalConfirm>

                    </div>
                </div>
            </>
        )

    }

    return (
        <>
            {isModal ?
                <>
                    {baseComponent()}
                </>
                :
                <BasicPage titulo="Tipos de Discrepancias de Documentos">
                    {baseComponent()}
                </BasicPage>
            }
        </>
    )
}
